
import { Alert, AlertColor, Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import { InformationCardComponent } from "./components/InformationCardComponent/InformationCardComponent";
import { OrganizationInfoWrapper } from "./components/OrgInfoTrackerListing/components/OrganizationInfoWrapper";
import { OrgInfoTrackerListing } from "./components/OrgInfoTrackerListing/OrgInfoTrackerListing";
import { OrgInfoActivitiesWrapper } from "./components/OrgInfoTrackerListing/components/OrgInfoActivitiesWrapper";
import { OrgInfoActivitiesHeader } from "./components/OrgInfoTrackerListing/components/OrgInfoActivitiesHeader";
import { useProfile } from "../../context/ProfileProvider/useProfile";
import KeydriveSnackbar from "../../components/KeydriveComponents/Snackbar/KeydriveSnackbar";
import { useNavigate, useParams } from "react-router-dom";
import { name } from "../WorkSpaceItem/WorkSpaceItemListStyle/ColumnStandard";


const OrganizationInfo = () => {
  const { nameOrg } = useParams();
  const profile = useProfile();
  const navigate = useNavigate();
  const [popupMessage, setPopupMessage] = useState<string | undefined>(undefined);
  const [severity, setSeverity] = useState<AlertColor>("success");
  const [userError, setUserError] = useState<boolean>(false);
  
  const handleClose = () => {
    setPopupMessage(undefined);
  }

  return (
    <div style={{marginTop: "30px"}}>
      <OrganizationInfoWrapper
        userError={userError}
      >
          <InformationCardComponent 
            setPopupMessage={setPopupMessage}
            setSeverity={setSeverity}
            setUserError={setUserError}
          />
          <OrgInfoActivitiesWrapper>
            <OrgInfoActivitiesHeader />
            <OrgInfoTrackerListing 
              setPopupMessage={setPopupMessage}
              setSeverity={setSeverity}
              setUserError={setUserError}
            />
          </OrgInfoActivitiesWrapper>
      </OrganizationInfoWrapper>
      <KeydriveSnackbar 
        message={popupMessage}
        open={popupMessage != undefined}
        variant={severity}
        onClose={handleClose}
      />
    </div>
  );
};


export default OrganizationInfo;
